import template from './tax-number.jade';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.commonTaxNumber', []).directive('cianAfCommonTaxNumber', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.validation = validation(this.form, 'taxNumber', {
      maxlength: 'Введите номер налоговой',
      parse: 'Введите номер налоговой',
      integer: 'Введите целое число',
      min: 'Введите номер налоговой',
    });
  },
  controllerAs: 'taxNumber',
  template,
})).name;
